import baseRequest  from '../baseRequest';
import AppConfig    from '../../app/config/AppConfig';

/* actions */
import * as Actions from '../../redux/actions';


class GetDetailedBenefitCouponHash extends baseRequest{

    constructor() {
        super();
        this.dispatch = null;
        this.response = null;
        this.name     = 'GetDetailedBenefitCouponHash';
        this.Config   = new AppConfig();
    }

    execute(dispatch, payload) {
        this.dispatch = dispatch;
        this.call(this.Config.api.requests.getDetailedBenefitCouponHash, payload);
    }

    //Parse successful response
    onSuccess() {
        let data = this.response.data;
        this.updateState(data);
    }

    //Dispatch actions to update redux state
    updateState(data) {
        this.dispatch(Actions.setCoupon(data));
    }
}


export default GetDetailedBenefitCouponHash;